import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { ThemeContext } from "../../../App";

const Users = ({ Ip }) => {
  const { isDark } = useContext(ThemeContext);

  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    role: "",
    password: "",
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const getRoleFromAccessLvl = (accessLvl) => {
    switch (accessLvl) {
      case 1:
        return "Admin";
      case 2:
        return "Editor";
      case 3:
        return "Viewer";
      default:
        return "Unknown";
    }
  };

  const fetchUsers = async () => {
    try {
      const formData = new FormData();
      formData.append("Action", "fetchAll");
      const res = await axios.post(`${Ip}/Dashboard/users_dash.php`, formData);

      if (res.data.success) {
        setUsers(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ================================
  // HANDLE INPUT
  // ================================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ================================
  // ADD USER
  // ================================
  const handleAdd = async () => {
    try {
      const form = new FormData();
      form.append("action", "add");

      Object.entries(formData).forEach(([key, value]) => {
        if (key !== "id") form.append(key, value);
      });

      const res = await axios.post(`${Ip}/Controllers/users.php`, form);

      if (res.data.success) {
        Swal.fire("Success", "User added successfully", "success");
        fetchUsers();
        closeModal();
      } else {
        Swal.fire("Error", "Failed to add user", "error");
      }
    } catch {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  // ================================
  // EDIT USER
  // ================================
  const handleEdit = (user) => {
    setFormData(user);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleUpdate = async () => {
    try {
      const form = new FormData();
      form.append("action", "edit");

      Object.entries(formData).forEach(([key, value]) => {
        form.append(key, value);
      });

      const res = await axios.post(`${Ip}/Controllers/users.php`, form);

      if (res.data.success) {
        Swal.fire("Updated", "User updated successfully", "success");
        fetchUsers();
        closeModal();
      } else {
        Swal.fire("Error", "Update failed", "error");
      }
    } catch {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  // ================================
  // DELETE USER
  // ================================
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This user will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const form = new URLSearchParams();
          form.append("action", "delete");
          form.append("id", id);

          const res = await axios.post(`${Ip}/Controllers/users.php`, form);

          if (res.data.success) {
            Swal.fire("Deleted!", "User removed.", "success");
            fetchUsers();
          } else {
            Swal.fire("Error", "Delete failed", "error");
          }
        } catch {
          Swal.fire("Error", "Something went wrong", "error");
        }
      }
    });
  };

  const closeModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setFormData({
      id: "",
      username: "",
      email: "",
      password: "",
    });
  };

  // ================================
  // UI
  // ================================
  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">User Management</h1>
        {/* <button
          onClick={() => setShowModal(true)}
          className="bg-light-brand dark:bg-dark-brand text-white px-4 py-2 rounded-lg"
        >
          + Add User
        </button> */}
      </div>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search user..."
        className="mb-4 w-full md:w-80 p-2 rounded-lg border border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface"
        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
      />

      {/* TABLE */}
      <div className="overflow-x-auto rounded-lg border border-light-border dark:border-dark-border">
        <table className="w-full text-left">
          <thead className="bg-light-surfaceSoft dark:bg-dark-surfaceSoft">
            <tr>
              <th className="p-3">ID</th>
              <th className="p-3">Username</th>
              <th className="p-3">Email</th>
              {/* <th className="p-3">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {users
              .filter((u) =>
                Object.values(u).some((val) =>
                  val?.toString().toLowerCase().includes(searchTerm),
                ),
              )
              .map((user) => (
                  <tr key={user.id} className="border-t">
                    <td className="p-3">{user.id}</td>
                    <td className="p-3">{user.username}</td>
                    <td className="p-3">{user.email}</td>
                    {/* <td className="p-3 flex gap-2">
                      <button
                        onClick={() => handleEdit(user)}
                        className="bg-blue-500 text-white px-3 py-1 rounded-md"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="bg-red-500 text-white px-3 py-1 rounded-md"
                      >
                        Delete
                      </button>
                    </td> */}
                  </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center">
          <div className="bg-light-surface dark:bg-dark-surface p-6 rounded-xl w-full max-w-lg">
            <h2 className="text-lg font-bold mb-4">
              {isEditing ? "Edit User" : "Add User"}
            </h2>

            <div className="space-y-3">
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                className="w-full p-2 rounded border"
              />
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full p-2 rounded border"
              />
              <input
                name="role"
                value={formData.role}
                onChange={handleChange}
                placeholder="Role"
                className="w-full p-2 rounded border"
              />
              {!isEditing && (
                <input
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  className="w-full p-2 rounded border"
                />
              )}
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={closeModal}
                className="px-4 py-2 border rounded-lg"
              >
                Cancel
              </button>
              <button
                onClick={isEditing ? handleUpdate : handleAdd}
                className="bg-light-brand dark:bg-dark-brand text-white px-4 py-2 rounded-lg"
              >
                {isEditing ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Users;
